const ALLOWED_TYPES = /^image\/(jpeg|jpg|png)$/i;

export function validateImageFile(file: File): boolean {
  return ALLOWED_TYPES.test(file.type);
}

export async function compressImage(
  file: File,
  maxWidth = 800,
  quality = 0.85
): Promise<File> {
  if (!validateImageFile(file)) {
    throw new Error('Only JPG and PNG images are allowed');
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;

      if (width <= maxWidth) {
        resolve(file);
        return;
      }

      const ratio = maxWidth / width;
      width = maxWidth;
      height = Math.round(height * ratio);

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas not supported'));
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Compression failed'));
            return;
          }
          const baseName = file.name.replace(/\.\w+$/, '') || 'image';
          resolve(new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' }));
        },
        'image/jpeg',
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
}
